export default function(n, ord
) {
  var s = String(n).split('.'), i = s[0], i10 = i.slice(-1),
    i100 = i.slice(-2), i1000 = i.slice(-3);
  if (ord) return ((i10 == 1 || i10 == 2 || i10 == 5 || i10 == 7 || i10 == 8)
    || (i100 == 20 || i100 == 50 || i100 == 70
      || i100 == 80)) ? 'one'
    : ((i10 == 3 || i10 == 4) || (i1000 == 100 || i1000 == 200
      || i1000 == 300 || i1000 == 400 || i1000 == 500 || i1000 == 600 || i1000 == 700
      || i1000 == 800
      || i1000 == 900)) ? 'few'
      : (i == 0 || i10 == 6 || (i100 == 40 || i100 == 60
        || i100 == 90)) ? 'many'
        : 'other';
  return (n == 1) ? 'one' : 'other';
}
